export default __webpack_public_path__ + "static/media/remoteH1.ba377544.png";